import React, { useLayoutEffect, useState } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAssets } from '@/hooks/use.assets';
import { AppLottieView } from '@/components/base/app.lottie.view';
import { Box } from '@/components/base/box';
import { AppTextView } from '@/components/base/app.text.view';
import styled from 'styled-components/native';
import { ViewStyle } from 'react-native';

interface Props {
  apis: UseQueryResult<any, AxiosError>[];
  style?: ViewStyle;
  children?: any;
}
export function LoaderContainer({ children, style, apis }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AxiosError | null>();
  const [initialized, setInitialized] = useState(false);
  const assets = useAssets();

  useLayoutEffect(() => {
    setError(apis.find((a) => a.error)?.error);
    setLoading(apis.some((a) => a.isLoading));
    if (!initialized) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, apis);

  if (!initialized || loading) {
    return (
      <Container style={style}>
        <LoaderAnimation source={assets.animations.loading} loop />
      </Container>
    );
  }
  if (!loading && error) {
    return (
      <Container style={style}>
        <AppTextView text={'مشکلی پیش اومده...'} />
      </Container>
    );
  }
  return children || null;
}

const Container = styled(Box)`
  flex: 1;
  align-items: center;
  justify-content: center;
  background-color: white;
`;

const LoaderAnimation = styled(AppLottieView)`
  width: ${({ theme }) => theme.hp(50)}px;
  height: ${({ theme }) => theme.hp(50)}px;
  justify-content: center;
  align-self: center;
`;
